enum TechnologyChangesPeriod {
    Quarter = "3mon",
    HalfYear = "6mon",
}

export default TechnologyChangesPeriod;
